import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const SortButton = React.memo(
  ({ onClickSort, iconName, arrayForSort, isFromMoreToLess = false, nutrient = 'calories' }) => {
    return (
      <Button
        onClick={() => onClickSort(arrayForSort, isFromMoreToLess, nutrient)}
        color="blue"
        icon
        size="mini"
      >
        <Icon name={iconName} />
      </Button>
    );
  },
);

export default SortButton;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/SortButton/index.jsx